import { render, staticRenderFns } from "./PermissionEdit.vue?vue&type=template&id=c9afd168&scoped=true&"
import script from "./PermissionEdit.vue?vue&type=script&lang=js&"
export * from "./PermissionEdit.vue?vue&type=script&lang=js&"
import style0 from "./PermissionEdit.vue?vue&type=style&index=0&id=c9afd168&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9afd168",
  null
  
)

export default component.exports